<div class="container mt-4 light-style flex-grow-1 container-p-y" style="min-height: 70vh;">

  <h4 class="font-weight-bold py-3 mb-4 text-center">
    {{'PROFILE.SETTINGS.SETTINGS' | translate}}
  </h4>

  <div class="card overflow-hidden">
    <div class="row">
      <div class="col-md-3 pt-0">
        <div class="list-group list-group-flush account-settings-links options">
          <a class="list-group-item list-group-item-action active" id="accountGeneralList" data-bs-toggle="list"
            href="#accountGeneral" role="tab" aria-controls="accountGeneral">{{'PROFILE.SETTINGS.GENERAL' |
            translate}}</a>
          <a class="list-group-item list-group-item-action" data-bs-toggle="list" href="#companyInfo">
            {{'PROFILE.SETTINGS.COMPANY' | translate}}</a>
          <!-- <a class="list-group-item list-group-item-action" data-bs-toggle="list"
                        href="#account-notifications">{{'PROFILE.SETTINGS.NOTIFICATIONS' | translate}}</a> -->
          <a class="list-group-item list-group-item-action" id="changePasswordList" data-bs-toggle="list"
            href="#accountChangePassword" role="tab" aria-controls="accountChangePassword">
            {{'PROFILE.SETTINGS.PASSWORD' | translate}}</a>
        </div>
      </div>
      <div class="col-md-9">
        <div class="tab-content">
          <div class="tab-pane fade active show" role="tabpanel" aria-labelledby="accountGeneralList"
            id="accountGeneral">
            <div class="card-body">
              <form [formGroup]="generalForm">
                <div class="row justify-content-start">
                  <div class="col-12 text-center mt-1 mb-4">
                    <span class="title">
                      {{'PROFILE.SETTINGS.GENERALINFO' | translate}}
                    </span>
                  </div>

                  <div class="col-12 col-lg-6 mt-2">
                    <label class="form-label section">{{'PROFILE.SETTINGS.NAME' | translate}}</label>
                    <input type="text" class="form-control" value="" formControlName="name">
                  </div>
                  <div class="col-12 col-lg-6 mt-2">
                    <label class="form-label section">{{'PROFILE.SETTINGS.SURNAME' | translate}}</label>
                    <input type="text" class="form-control" value="" formControlName="surname">
                  </div>
                  <div class="col-12 col-lg-6 mt-2">
                    <label class="form-label section">{{'PROFILE.SETTINGS.EMAIL' | translate}}
                    </label>
                    <input type="text" class="form-control mb-1" value="" formControlName="email">
                  </div>
                  <div class="col-12 col-lg-6 mt-2">
                    <label for="country" class="form-label section">{{'PROFILE.SETTINGS.COUNTRY' |
                      translate}}</label>
                    <select class="form-select" id="country" aria-label="select example" formControlName="country">
                      <option [ngValue]="null" disabled>{{'PROFILE.SETTINGS.SELECTCOUNTRY' |
                        translate}}</option>
                      <option *ngFor="let country of countriesData" [ngValue]="country.id">
                        {{ country.common_name }}
                      </option>
                    </select>
                  </div>
                  <div *ngIf="generalForm.get('country')?.value == 12; else foreignBlock" class="col-12 col-lg-6 mt-2">
                    <label for="fiscalcode" class="form-label section">{{'PROFILE.SETTINGS.FISCALCODE' |
                      translate}}</label>
                    <input type="text" class="form-control" id="fiscalcode" formControlName="fiscalcode">
                  </div>
                  <ng-template #foreignBlock>
                    <div class="col-12 col-lg-6 mt-2">
                      <label for="licensenumber" class="form-label section">{{'PROFILE.SETTINGS.LICENSENUMBER' |
                        translate}}</label>
                      <input type="text" class="form-control" id="licensenumber" formControlName="licensenumber">
                    </div>
                  </ng-template>
                  <div class="col-12 col-lg-6 mt-2">
                    <label class="form-label section">{{'PROFILE.SIGNUP.PHONE' | translate}}</label>
                    <input type="text" class="form-control" value="" formControlName="phone">
                  </div>
                  <div class="col-12 col-lg-6 mt-2">
                    <label class="form-label section">{{'PROFILE.SIGNUP.WHATSAPP' | translate}}</label>
                    <input type="text" class="form-control" value="" formControlName="phone_whatsapp">
                  </div>
                </div>
              </form>

              <div class="row justify-content-end">
                <div class="col-auto mt-3">
                  <button type="button" [disabled]="generalForm.invalid || !generalForm.dirty" class="btn btn-dark"
                    (click)="updateGeneral()">
                    {{'PROFILE.SETTINGS.SAVECHANGES' | translate}}
                  </button>
                </div>
              </div>
            </div>
          </div>

          <div class="tab-pane container-fluid fade" id="accountChangePassword" role="tabpanel"
            aria-labelledby="changePasswordList">
            <div class="card-body pb-2">
              <form [formGroup]="modifyPasswordForm" style="margin: 0 auto">
                <div class="row justify-content-start">
                  <div class="col-12 text-center  mt-1 mb-4">
                    <span class="title">
                      {{'PROFILE.SETTINGS.CHANGEPASSWORD' | translate}}
                    </span>
                  </div>

                  <div class="col-12 col-lg-6 mt-2 input-container">
                    <label for="password1" class="form-label section">
                      {{'PROFILE.SETTINGS.CURRENTPSW' | translate}}</label>
                    <input [type]="type1" id="password1" formControlName="current_password" class="form-control">
                    <i class="bi bi-eye icon" [ngClass]="{'bi-eye': !toggled1, 'bi-eye-slash': toggled1}"
                      id="togglePassword" (click)="seePassword('password1')">
                    </i>
                  </div>
                  <div class="col-12 col-lg-6 mt-2 input-container">
                    <label for="password2" class="form-label section">{{'PROFILE.SETTINGS.NEWPSW' |
                      translate}}</label>
                    <input [type]="type2" id="password2" formControlName="password" class="form-control">
                    <i class="bi bi-eye icon" [ngClass]="{'bi-eye': !toggled2, 'bi-eye-slash': toggled2}"
                      id="togglePassword" (click)="seePassword('password2')">
                    </i>
                  </div>
                  <div class="col-12 col-lg-6 mt-2 input-container">
                    <label for="password3" class="form-label section">{{'PROFILE.SETTINGS.REPEATPSW' |
                      translate}}</label>
                    <input [type]="type3" id="password3" formControlName="password_confirmation" class="form-control">
                    <i class="bi bi-eye icon" [ngClass]="{'bi-eye': !toggled3, 'bi-eye-slash': toggled3}"
                      id="togglePassword" (click)="seePassword('password3')">
                    </i>
                  </div>
                </div>
              </form>

              <div class="row justify-content-end">
                <div class="col-auto mt-3">
                  <button type="button" class="btn btn-dark" [disabled]="modifyPasswordForm.invalid"
                    (click)="saveNewPassword()">
                    {{'PROFILE.SETTINGS.BUTTON_UPDATEPWD' | translate}}
                  </button>
                </div>
              </div>
            </div>
          </div>

          <!-- COMPANY -->
          <div class="tab-pane container-fluid fade" id="companyInfo">
            <div class="card-body pb-2">
              <form [formGroup]="companyForm" style="margin: 0 auto">
                <div class="row justify-content-start">
                  <div class="col-12 text-center mt-1 mb-4">
                    <span class="title">
                      {{'PROFILE.SETTINGS.COMPANYINFO' | translate}}
                    </span>
                  </div>

                  <div class="col-12 col-lg-6 mt-2">
                    <label for="company_name" class="form-label section">
                      {{'PROFILE.SETTINGS.COMPANYNAME' | translate}}</label>
                    <input class="form-control" type="text" id="company_name" formControlName="company_name">
                  </div>
                  <div *ngIf="generalForm.get('country')?.value == 12" class="col-12 col-lg-6 mt-2">
                    <label for="vat" class="form-label section">
                      {{'PROFILE.SETTINGS.VAT' | translate}}
                    </label>
                    <input type="text" class="form-control" id="vat" formControlName="vat">
                  </div>
                  <div class="col-12 col-lg-6 mt-2">
                    <label for="phone" class="form-label section">
                      {{'PROFILE.SETTINGS.PHONE' | translate}}
                    </label>
                    <input type="text" class="form-control" id="phone" formControlName="phone">
                  </div>
                </div>
              </form>
              <div class="row justify-content-end">
                <div class="col-auto mt-3">
                  <button type="button" class="btn btn-dark" (click)="updateCompany()" [disabled]="!companyForm.dirty">
                    {{'PROFILE.SETTINGS.BUTTON_UPDATECOMPANY' | translate}}
                  </button>
                </div>
              </div>
            </div>
          </div>


          <!-- <div class="tab-pane fade" id="account-notifications">
                        <div class="card-body pb-2">

                            <h6 class="mb-4 section">{{'PROFILE.SETTINGS.ACTIVITY' | translate}}</h6>

                            <div class="form-group">
                                <label class="switcher">
                                    <input type="checkbox" class="switcher-input" checked="">
                                    <span class="switcher-indicator">
                                        <span class="switcher-yes"></span>
                                        <span class="switcher-no"></span>
                                    </span>
                                    <span class="switcher-label">{{'PROFILE.SETTINGS.NOTIFICATIONS1' | translate}}</span>
                                </label>
                            </div>
                            <div class="form-group">
                                <label class="switcher">
                                    <input type="checkbox" class="switcher-input" checked="">
                                    <span class="switcher-indicator">
                                        <span class="switcher-yes"></span>
                                        <span class="switcher-no"></span>
                                    </span>
                                    <span class="switcher-label">{{'PROFILE.SETTINGS.NOTIFICATIONS2' | translate}}</span>
                                </label>
                            </div>
                            <div class="form-group">
                                <label class="switcher">
                                    <input type="checkbox" class="switcher-input">
                                    <span class="switcher-indicator">
                                        <span class="switcher-yes"></span>
                                        <span class="switcher-no"></span>
                                    </span>
                                    <span class="switcher-label">{{'PROFILE.SETTINGS.NOTIFICATIONS3' | translate}}</span>
                                </label>
                            </div>
                        </div>
                        <hr class="border-light m-0">
                        <div class="card-body pb-2">

                            <h6 class="mb-4 section">{{'PROFILE.SETTINGS.NOTIFICATIONS4' | translate}}</h6>

                            <div class="form-group">
                                <label class="switcher">
                                    <input type="checkbox" class="switcher-input" checked="">
                                    <span class="switcher-indicator">
                                        <span class="switcher-yes"></span>
                                        <span class="switcher-no"></span>
                                    </span>
                                    <span class="switcher-label">{{'PROFILE.SETTINGS.NOTIFICATIONS5' | translate}}</span>
                                </label>
                            </div>
                            <div class="form-group">
                                <label class="switcher">
                                    <input type="checkbox" class="switcher-input">
                                    <span class="switcher-indicator">
                                        <span class="switcher-yes"></span>
                                        <span class="switcher-no"></span>
                                    </span>
                                    <span class="switcher-label">{{'PROFILE.SETTINGS.NOTIFICATIONS6' | translate}}</span>
                                </label>
                            </div>
                            <div class="form-group">
                                <label class="switcher">
                                    <input type="checkbox" class="switcher-input" checked="">
                                    <span class="switcher-indicator">
                                        <span class="switcher-yes"></span>
                                        <span class="switcher-no"></span>
                                    </span>
                                    <span class="switcher-label">{{'PROFILE.SETTINGS.NOTIFICATIONS7' | translate}}</span>
                                </label>
                            </div>

                        </div>
                    </div> -->
        </div>
      </div>
    </div>
  </div>
</div>
